import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Button from 'react-bootstrap/lib/Button';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import ReviewItemAboutYou from './ReviewItemAboutYou';
import Loader from '../Loader';

import messages from '../../locale/messages';

import noListImage from '/public/SiteImages/noReviewImage.svg';

import s from './Reviews.css';
import bt from '../../components/commonStyle.css';

const PastReviews = ({ data = {}, loadMore, searchKey, isReviewLoading }) => {
  const { loading, userReviews } = data || {};

  const hasReviews =
    userReviews &&
    userReviews.results &&
    userReviews.results.length > 0;

  const shouldShowLoadMore =
    hasReviews && userReviews.count > userReviews.results.length;

  return (
    <>
      {loading && <Loader type="text" />}

      {!loading && (!hasReviews || userReviews === null) && (
        <div className={cx(s.textCenter, s.marginTop)}>
          <img src={noListImage} className={s.mobWidth} alt="No Reviews" />
          <div className={s.noListHeading}>
            <FormattedMessage {...messages.noReviewHeading} />
          </div>
          <div className={cx(s.noListSubHeading)}>
            <FormattedMessage {...messages.noReviewSubHeding} />
          </div>
        </div>
      )}

      {!loading && hasReviews && (
        <div className={cx(s.panelNolist, s.spaceTop6)}>
          <ul className={cx(s.listStyle, s.recommondations, s.pastReviewBottom)}>
            {userReviews.results.map((item, index) => {
              if (item?.authorData && item?.userData) {
                return (
                  <ReviewItemAboutYou
                    key={index}
                    picture={item.authorData.picture}
                    firstName={item.authorData.firstName}
                    lastName={item.authorData.lastName}
                    otherUserName={item.userData.firstName}
                    otherUserProfileId={item.userData.profileId}
                    profileId={item.authorData.profileId}
                    reviewContent={item.reviewContent}
                    createdAt={item.createdAt}
                    response={item.response}
                    listData={item.listData}
                    listTitle={item?.singleReservationData?.listTitle}
                    otherUserResponse
                    showUserName
                    rating={item.rating}
                  />
                );
              }
              return null;
            })}
          </ul>
        </div>
      )}

      {!loading && shouldShowLoadMore && (
        <Row>
          <Col lg={12} md={12} sm={12} xs={12} className={s.spaceBottom20}>
            <div className={cx(s.space2, s.textCenter, s.marginTop)}>
              <Button
                className={cx(s.btn, bt.btnPrimary, s.loadMoreBtn)}
                onClick={() => loadMore('me', null, searchKey)}
                disabled={isReviewLoading}
              >
                <FormattedMessage {...messages.loadMore} />...
              </Button>
            </div>
          </Col>
        </Row>
      )}
    </>
  );
};

PastReviews.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool,
    userReviews: PropTypes.shape({
      results: PropTypes.arrayOf(PropTypes.object),
      count: PropTypes.number
    })
  }),
  loadMore: PropTypes.func,
  searchKey: PropTypes.string,
  isReviewLoading: PropTypes.bool
};

export default withStyles(s, bt)(PastReviews);